import { Directive, Input, OnInit, ViewContainerRef, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appHasRoleSpace]'
})
export class CheckSpaceRoleDirective implements OnInit {
  // the role the user must have
  @Input() public appHasRoleSpace: string;

  isVisible = false;
  constructor(
    private viewContainerRef: ViewContainerRef,
    private templateRef: TemplateRef<any>,
  ) {
  }

  ngOnInit() {
    if (this.appHasRoleSpace && this.appHasRoleSpace === 'edit') {
      this.isVisible = true;
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    } else {
      this.isVisible = false;
      this.viewContainerRef.clear();
    }
  }
}
